import React, { useEffect, useRef, useState } from "react";
import {
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router-dom";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { FormControlLabel, Grid, styled, Switch } from "@material-ui/core";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import { accessRestrictionConfig } from "assets/properties/properties";
import { parseAndSetFlag } from "utils/Utils";
import ToastModal from "views/components/ToastModal";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import { accessTableColumnsCounts } from "assets/properties/properties";
import AccessRestrictionCreate from "./AccessRestrictionCreate";
import { coreList } from "assets/properties/properties";
import { losList } from "assets/properties/properties";
import { lmsList } from "assets/properties/properties";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { toastAction } from "assets/properties/properties";
import { splitIntoCustomChunks } from "utils/Utils";
import { sortByString } from "utils/Utils";
import { particularDesignationAccess } from "assets/properties/properties";
import { personalLoanLosList } from "assets/properties/properties";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any,
  value: PropTypes.any,
};
function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    // display: "flex",
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
    // width: "14%",
    "& .MuiTabs-indicator": {
      display: "none",
      //backgroundColor: "orange"
    },
  },
  tabPanels: {
    width: "86%",
  },
  Container: {
    marginTop: "20px",
  },
  boxContainer: {
    width: "1024px",
    '@media only screen and (max-width: 600px)': {
       width: "auto",
       overflow:'scroll',
       height:'45vh',
       padding:'0px',
       margin:'0px',
    },
  },
}));
const AccessRestrictionTabs = ({ classes }) => {
  const location = useLocation();
  const classeCoponent = useStyles();
  let navigate = useNavigate();
  const [value, setValue] = React.useState(
    location?.state?.navigateTab ? location?.state?.navigateTab : 0
  );
  const outletData = useOutletContext();

  const [removeCoreMasterListCodes, setRemoveCoreMasterListCodes] = useState("");
  const [removeLosMasterListCodes, setRemoveLosMasterListCodes] = useState("");
  const [removeLmsMasterListCodes, setRemoveLmsMasterListCodes] = useState("");
  const [showTabsAsPerTheDesignationFlag,setShowTabsAsPerTheDesignationFlag] = useState(false);

  const [masterName, setMasterName] = useState("");
  const [designationName, setDesignationName] = useState("");
  const [roleOrDesignationList, setRoleOrDesignationList] = useState([]);
  const [disabledButton, setDisabledButton] = useState(false);
  const { authToken } = useSelector((state) => state.login.authData);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [redirectURL, setRedirectURL] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);
  const [coreTreeData, setCoreTreeData] = useState([]);
  const [losTreeData, setLosTreeData] = useState([]);
  const [lmsTreeData, setLmsTreeData] = useState([]);
  const [coreColumns, setCoreColumns] = useState([]);
  const [losColumns, setLosColumns] = useState([]);
  const [lmsColumns, setLmsColumns] = useState([]);
  const [rawData, setRawData] = useState([]);
  const [parentMap, setParentMap] = useState({});
  const [selectedCodesCore, setSelectedCodesCore] = useState(new Set());
  const [selectedCodesLos, setSelectedCodesLos] = useState(new Set());
  const [selectedCodesLms, setSelectedCodesLms] = useState(new Set());
  const [coreInitialized, setCoreInitialized] = useState(false);
  const [losInitialized, setLosInitialized] = useState(false);
  const [lmsInitialized, setLmsInitialized] = useState(false);
  const [currentDesignationId, setCurrentDesignationId] = useState("");
  const [coreMasterEnabled,setCoreMasterEnabled] = useState(true);
  const [losMasterEnabled,setLosMasterEnabled] = useState(true);
  const [lmsMasterEnabled,setLmsMasterEnabled] = useState(true);
  const { userDetails } = useSelector((state) => state.userDetail.userDetails);
  const [personalLoanEnabled, setPersoanlLoanEnabled]=useState(false)
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL, { state: { masterName, designationName } });
    }
  };
  
  useEffect(() => {
    getFeatureFlag();
  }, []);

  const getFeatureFlag = async () => {
    const result = await apiHandler({
      url: endpoint.FEATURE_FLAG,
    });
    setRemoveCoreMasterListCodes(result?.data?.removeCoreMasterListCodes);
    setRemoveLosMasterListCodes(result?.data?.removeLosMasterListCodes);
    setRemoveLmsMasterListCodes(result?.data?.removeLmsMasterListCodes);
    setShowTabsAsPerTheDesignationFlag(parseAndSetFlag(result?.data?.showTabsAsPerTheDesignationFlag));
    setPersoanlLoanEnabled(parseAndSetFlag(result?.data?.enablePersonalLoanFlag));
    loadData(parseAndSetFlag(result?.data?.showTabsAsPerTheDesignationFlag))
  };
  const loadData = async (showTabs) => {
    if (showTabs) {
      await getDesignationFindAll(showTabs);
    } else {
      await getRoleFindAll(showTabs);
    }
  };
  useEffect(() => {
    const loadData = async () => {
      if (designationName) {
        setSelectedCodesCore(new Set());
        setSelectedCodesLos(new Set());
        setSelectedCodesLms(new Set());

        setCoreInitialized(false);
        setLosInitialized(false);
        setLmsInitialized(false);

        await GetData();
      }
    };
    loadData();
  }, [designationName]);
  const getDesignationFindAll = async (showTabs) => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.DESIGNATION_FINDALL,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data) {
      const filteredData = result?.data?.filter((item) => !particularDesignationAccess.includes(item?.designation));
      const desingationWise = particularDesignationAccess.includes(userDetails?.designation) ? result?.data :  filteredData;
      const sortedArray = sortByString(desingationWise, "designation", true);
      setRoleOrDesignationList(sortedArray);
      await getUserDetails(showTabs);
    }
  };
  const getRoleFindAll = async (showTabs) => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.MASTER_ROLE_FIND,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data) {
      const expectUserData = result?.data?.filter(
        (item) => item.name !== "User"
      );
      expectUserData.push({
        role: "role_branch_checker",
        name: "Branch Checker",
      });
      setRoleOrDesignationList(expectUserData);
      await getUserDetails(showTabs);
    }
  };
  const getUserDetails = async (showTabs) => {
    const searchParam = showTabs ? userDetails?.designation : userDetails?.role
    setDesignationName(searchParam);
  };
  const GetData = async () => {
    setCallInProgress(true);
    const query = showTabsAsPerTheDesignationFlag
      ? `designation=${designationName}`
      : `role=${designationName}`;
    const result = await apiHandler({
      url: endpoint.UI_RESTRICTION_FIND + query,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code || result?.data?.user_description) {
      setRawData({});
      setCurrentDesignationId("");
    } else {
      setRawData(result?.data);
      setCurrentDesignationId(result?.data?.id);
    }
  };
  const buildTree = (data, parentKey = "") =>
    Object.entries(data).map(([key, value]) => {
      const fullKey = parentKey ? `${parentKey}.${key}` : key;
      return {
        key: fullKey,
        name: value.name,
        code: value.code,
        children: value.children ? buildTree(value.children, fullKey) : [],
      };
    });
  const parseCodeArray = (input) => {
    if (Array.isArray(input)) return input;

    if (typeof input === "string") {
      try {
        const jsonReady = input.replace(/'/g, '"');
        return JSON.parse(jsonReady);
      } catch (e) {
        console.log("Failed to parse codesToRemove:", input, e);
        return [];
      }
    }

    return [];
  };
  const filterByCodes = (listObj, codesToRemove) => {
   codesToRemove = parseCodeArray(codesToRemove);
  const codeSet = new Set(codesToRemove?.map((code) => code.trim()));
  const recursiveFilter = (obj) => {
    const filtered = {};
    for (const [key, value] of Object.entries(obj)) {
      const code = value?.code?.trim();
      if (codeSet.has(code)) continue;

      const newItem = { ...value };

      if (value.children) {
        const filteredChildren = recursiveFilter(value.children);
        if (Object.keys(filteredChildren).length > 0) {
          newItem.children = filteredChildren;
        } else {
          delete newItem.children;
        }
      }

      filtered[key] = newItem;
    }

    return filtered;
  };

  return recursiveFilter(listObj);
};

  useEffect(() => {
    if (!currentDesignationId || !rawData?.restrictions) {
      setCoreMasterEnabled(true);
      setLosMasterEnabled(true);
      setLmsMasterEnabled(true);
    return;
    }

    let restrictionObj;
    try {
      restrictionObj = JSON.parse(rawData.restrictions);
    } catch (e) {
      console.log("Invalid JSON in restrictions:", rawData.restrictions);
      return;
    }

    if (restrictionObj?.disabledModule) {
      setCoreMasterEnabled(!restrictionObj.disabledModule.core);
      setLosMasterEnabled(!restrictionObj.disabledModule.los);
      setLmsMasterEnabled(!restrictionObj.disabledModule.lms);
    }

    const collectTreeCodes = (nodes, set = new Set()) => {
      for (const node of nodes) {
        set.add(node.code);
        if (node.children?.length) {
          collectTreeCodes(node.children, set);
        }
      }
      return set;
    };
    if (coreTreeData.length > 0 && restrictionObj.core && !coreInitialized) {
      const backendDisabled = restrictionObj.core
        .filter(item => item.disabled === true)
        .map(item => item.code);

      const backendAllCodes = new Set(
        restrictionObj.core.map(item => item.code)
      );

      const treeCodes = collectTreeCodes(coreTreeData);

      const newDisabledCodes = [...treeCodes].filter(
        code => !backendAllCodes.has(code)
      );

      setSelectedCodesCore(
        new Set([...backendDisabled, ...newDisabledCodes])
      );

      setCoreInitialized(true);
    }

    if (losTreeData.length > 0 && restrictionObj.los && !losInitialized) {
      const backendDisabled = restrictionObj.los
        .filter(item => item.disabled === true)
        .map(item => item.code);

      const backendAllCodes = new Set(
        restrictionObj.los.map(item => item.code)
      );

      const treeCodes = collectTreeCodes(losTreeData);

      const newDisabledCodes = [...treeCodes].filter(
        code => !backendAllCodes.has(code)
      );

      setSelectedCodesLos(
        new Set([...backendDisabled, ...newDisabledCodes])
      );

      setLosInitialized(true);
    }

    if (lmsTreeData.length > 0 && restrictionObj.lms && !lmsInitialized) {
      const backendDisabled = restrictionObj.lms
        .filter(item => item.disabled === true)
        .map(item => item.code);

      const backendAllCodes = new Set(
        restrictionObj.lms.map(item => item.code)
      );

      const treeCodes = collectTreeCodes(lmsTreeData);

      const newDisabledCodes = [...treeCodes].filter(
        code => !backendAllCodes.has(code)
      );

      setSelectedCodesLms(
        new Set([...backendDisabled, ...newDisabledCodes])
      );

      setLmsInitialized(true);
    }
  }, [
    coreTreeData,
    losTreeData,
    lmsTreeData,
    rawData?.restrictions,
    currentDesignationId,
  ]);
const losListData = personalLoanEnabled ? personalLoanLosList : losList;
  useEffect(() => {
    let list = {};

    if (value === 0) {
      list = filterByCodes(coreList, removeCoreMasterListCodes);
      const builtTree = buildTree(list);
      setCoreTreeData(builtTree);
      const tableColumns = splitIntoCustomChunks(
        builtTree,
        accessTableColumnsCounts.core
      );
      setCoreColumns(tableColumns);
    } else if (value === 1) {
      list = filterByCodes(losListData, removeLosMasterListCodes);
      const builtTree = buildTree(list);
      setLosTreeData(builtTree);
      const tableColumns = splitIntoCustomChunks(
        builtTree,
        accessTableColumnsCounts.los
      );
      setLosColumns(tableColumns);
    } else if (value === 2) {
      list = filterByCodes(lmsList, removeLmsMasterListCodes);
      console.log(list,'ahskjdhakhdk')
      const builtTree = buildTree(list);
      setLmsTreeData(builtTree);
      const tableColumns = splitIntoCustomChunks(
        builtTree,
        accessTableColumnsCounts.lms
      );
      setLmsColumns(tableColumns);
    }
  }, [value,removeCoreMasterListCodes,removeLosMasterListCodes,removeLmsMasterListCodes]);

  const generateFinalSavePayload = () => {
    const parseCodeArray = (input) => {
      if (Array.isArray(input)) return input;
      if (typeof input === "string") {
        try {
          const jsonReady = input.replace(/'/g, '"');
          return JSON.parse(jsonReady);
        } catch {
          return [];
        }
      }
      return [];
    };

    const collectSelectedCodes = (nodes, selectedSet, collector) => {
      for (const node of nodes) {
        if (selectedSet.has(node.code)) {
          collector.add(node.code);
        }
        if (node.children?.length) {
          collectSelectedCodes(node.children, selectedSet, collector);
        }
      }
    };

    const flattenMasterList = (tree, selectedSet, removeList) => {
      const flat = [];
      const removeSet = new Set(
        parseCodeArray(removeList).map((code) => code.trim())
      );

      const recurse = (entries, parentRemoved = false) => {
        for (const value of Object.values(entries)) {
          const code = value.code?.trim();
          const isRemoved = removeSet.has(code);
          const isSelected = selectedSet.has(code);
          const disabled = isRemoved || parentRemoved || isSelected;

          flat.push({
            name: value.name,
            code: code,
            disabled,
          });

          if (value.children) {
            recurse(value.children, isRemoved);
          }
        }
      };

      recurse(tree);
      return flat;
    };

    const result = {};
    //---Disabled Module----
    result.disabledModule = {
      core:!coreMasterEnabled,
      los:!losMasterEnabled,
      lms:!lmsMasterEnabled,
    }

    // --- CORE ---
    const coreSelected = new Set();
    collectSelectedCodes(coreTreeData, selectedCodesCore, coreSelected);
    result.core = flattenMasterList(
      coreList,
      coreSelected,
      removeCoreMasterListCodes
    );

    // --- LOS ---
    const losSelected = new Set();
    collectSelectedCodes(losTreeData, selectedCodesLos, losSelected);
    result.los = flattenMasterList(
      losListData,
      losSelected,
      removeLosMasterListCodes
    );

    // --- LMS ---
    const lmsSelected = new Set();
    collectSelectedCodes(lmsTreeData, selectedCodesLms, lmsSelected);
    result.lms = flattenMasterList(
      lmsList,
      lmsSelected,
      removeLmsMasterListCodes
    );
    return result;
  };

  const handleEdit = async () => {
    const payload = generateFinalSavePayload();
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.UI_RESTRICTION_UPDATE + currentDesignationId,
      method: "PUT",
      authToken: authToken,
      data: {
        role: showTabsAsPerTheDesignationFlag ? null : designationName,
        designation: showTabsAsPerTheDesignationFlag ? designationName : null,
        restrictions: JSON.stringify(payload),
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate(toastAction?.error, res?.data?.user_description, true);
      return "ERROR";
    } else {
      toastUpdate(toastAction?.success, "Edited Successfully", true);
      return "SUCCESS";
    }
  };
  const handelSave = async () => {
    const payload = generateFinalSavePayload();
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.UI_RESTRICTION_CREATE,
      method: "POST",
      authToken: authToken,
      data: {
        role: showTabsAsPerTheDesignationFlag ? null : designationName,
        designation: showTabsAsPerTheDesignationFlag ? designationName : null,
        restrictions: JSON.stringify(payload),
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate(toastAction?.error, res?.data?.user_description, true);
      return "ERROR";
    } else {
      toastUpdate(toastAction?.success, "Created Successfully", true);
      return "SUCCESS";
    }
  };
  const buildParentMap = (nodes, map = {}, parent = null) => {
    for (const node of nodes) {
      if (parent) {
        map[node.code] = parent;
      }
      if (node.children?.length) {
        buildParentMap(node.children, map, node);
      }
    }
    return map;
  };
  useEffect(() => {
    let map = {};
    if (value === 0 && coreTreeData) {
      map = buildParentMap(coreTreeData);
    } else if (value === 1 &&  losTreeData) {
      map = buildParentMap(losTreeData);
    } else {
      map = buildParentMap(lmsTreeData);
    }
    setParentMap(map);
  }, [coreTreeData, losTreeData, lmsTreeData]);

  const handleChange = (event, newValue) => {
    event?.stopPropagation();
    event?.preventDefault();
    setValue(newValue);
  };
  const dispatch = useDispatch();
  const updateSelectedCodesCore = (val) => {
    setSelectedCodesCore(val);
  };
  const updateSelectedCodesLos = (val) => {
    setSelectedCodesLos(val);
  };
  const updateSelectedCodesLms = (val) => {
    setSelectedCodesLms(val);
  };
  const Android12Switch = styled(Switch)(({ theme }) => ({
    padding: 8,
    '& .MuiSwitch-switchBase': {
      // padding: 10,
      '&.Mui-checked': {
        transform: 'translateX(22px)',
        color: '#4caf50',
        '& + .MuiSwitch-track': {
          backgroundColor: '#c8e6c9',
          opacity: 1,
        },
        '& .MuiSwitch-thumb': {
          backgroundColor: '#4caf50',
          '&:before': {
            content: '""',
            position: 'absolute',
            width: '100%',
            height: '100%',
            padding:10,
            backgroundImage: `url("data:image/svg+xml;utf8")`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
          },
        },
      },
      '& .MuiSwitch-thumb': {
        backgroundColor: '#f44336',
        '&:before': {
          content: '""',
          position: 'absolute',
          width: '100%',
          height: '100%',
          backgroundImage: `url("data:image/svg+xml;utf8")`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        },
      },
    },
    '& .MuiSwitch-thumb': {
      width: 20,
      height: 20,
      position: 'relative',
    },
    '& .MuiSwitch-track': {
      borderRadius: 20,
      backgroundColor: '#e0e0e0',
      opacity: 1,
    },
  }));
  const label = (label,setState,state) => {
    return (
      <FormControlLabel
            control={
              <Android12Switch
                checked={state}
                onChange={(e) =>{e.stopPropagation(); setState(!state)}}
                name="checkedB"
                color="primary"
              />
            }
            label={
              <Typography
                style={{
                  color: "#000000",
                  fontWeight: 400,
                  textDecoration:"none",
                  fontSize:"16px",
                  marginLeft:"20px"
                }}
              >
                {label}
              </Typography>
            }
          />
    )
  }
  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <SubHeader
            label={accessRestrictionConfig?.label}
            button1=" Save"
            button1click={currentDesignationId ? handleEdit : handelSave}
            disabled1={disabledButton}
            select1={designationName}
            select1Label={
              showTabsAsPerTheDesignationFlag ? "Designation Name" : "Role Name"
            }
            setSelect1={setDesignationName}
            select1Data={roleOrDesignationList}
            select1Type={
              showTabsAsPerTheDesignationFlag ? "designation" : "roleNew"
            }
          />
        </Grid>
        <Tabs
           orientation="horizontal"
          variant="scrollable"
          value={value}
          onChange={handleChange}
        >
          <Tab label={label("CORE",setCoreMasterEnabled,coreMasterEnabled)} {...a11yProps(0)} />
          <Tab label={label("LOS",setLosMasterEnabled,losMasterEnabled)} {...a11yProps(1)} />
          <Tab label={label("LMS",setLmsMasterEnabled,lmsMasterEnabled)} {...a11yProps(2)} />
        </Tabs>
        {value === 0 && coreMasterEnabled && <TabPanel value={value} index={0} className={classeCoponent.Container}>
          <AccessRestrictionCreate
            columns={coreColumns}
            selectedCodes={selectedCodesCore}
            setSelectedCodes={updateSelectedCodesCore}
            parentMap={parentMap}
            styleClass={classeCoponent.boxContainer}
          />
        </TabPanel>
}
        {value === 1 && losMasterEnabled &&
              <TabPanel 
              value={value}
              index={1} 
            className={classeCoponent.Container}>
          <AccessRestrictionCreate
            columns={losColumns}
            selectedCodes={selectedCodesLos}
            setSelectedCodes={updateSelectedCodesLos}
            parentMap={parentMap}
            styleClass={classeCoponent.boxContainer}
          />
        </TabPanel>}
        {value === 2 && lmsMasterEnabled && (
          <TabPanel
            value={value}
            index={2}
            className={classeCoponent.Container}
          >
            <AccessRestrictionCreate
              columns={lmsColumns}
              selectedCodes={selectedCodesLms}
              setSelectedCodes={updateSelectedCodesLms}
              parentMap={parentMap}
              styleClass={classeCoponent.boxContainer}
            />
          </TabPanel>
        )}
      </Grid>
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}

      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </>
  );
};

AccessRestrictionTabs.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.node,
  index: PropTypes.any,
  value: PropTypes.any,
};

export default AccessRestrictionTabs;
